import React from "react";
import { useTranslation } from "react-i18next";
import { Users } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const CalendarEmployeeSelector = ({ employees, selectedEmployeeId, setSelectedEmployeeId }) => {
  const { t } = useTranslation();

  return (
    <Card>
    <CardContent className="pt-6">
      <div className="flex items-center gap-4">
        <Users className="h-5 w-5 text-gray-400" />
        <div className="flex-1">
          <Select value={selectedEmployeeId?.toString()} onValueChange={setSelectedEmployeeId}>
            <SelectTrigger>
              <SelectValue placeholder={t("planning.calendarView.selectEmployee")} />
            </SelectTrigger>
            <SelectContent>
              {employees.map((emp) => (
                <SelectItem key={emp.id} value={emp.id.toString()}>
                  {emp.last_name} {emp.first_name} - {emp.badge_number}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </CardContent>
    </Card>
  );
};

export default CalendarEmployeeSelector;
